import React from "react"
import { Route, Routes } from "react-router-dom"
import Dashboard from "../pages/dashboard/dashboard"
import AppLayout from "../layouts/app-layout"
import BookAppointments from "../pages/book-appointments/book-appointments"
import ProtectedRoute from "../utils/ProtectedRoute"

const UserRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={
        <ProtectedRoute>
          <AppLayout>
            <Dashboard />
          </AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/book-appointments" element={
        <ProtectedRoute>
          <AppLayout>
            <BookAppointments />
          </AppLayout>
        </ProtectedRoute>
      } />
    </Routes>
  )
}

export default UserRoutes
